<template>
  <section class="sec-top-intro">
    <div class="box-top-slide">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202510_01.png" />
      </div>
      <div class="img-top-slide_text">
        <h2 class="mb-0 text-right"><span>手は顔より皮膚が薄い“敏感パーツ”</span><br>日によって“手のシワが濃く見える”のはなぜ？</h2>
      </div>
    </div>
  </section>

  <section class="column_content">
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202510_02.png">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">手のシワが今日は目立つ...そんな日ないですか</h3>
        <p class="mb-3">ふとスマホを持ったとき、PCのキーボードに触れたとき。<br>「今日、なんだか手のシワが深く見える気がする…」<br>そんな瞬間、ありませんか？</p>
        <p class="mb-3">実は、手元は顔より皮膚が薄く、皮脂腺も少ない“敏感パーツ”。</p>
        <p class="mb-3">にもかかわらず、手洗い・家事・PC・スマホなど、一日中動き続けている“働きもの”です。</p>
        <p>守られることより、負荷を受ける時間の方が圧倒的に長いため、乾燥や摩擦の影響が、ダイレクトにシワの見え方に表れやすいのです。</p>
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">日によって“シワの見え方”が変わるのはなぜ？</h3>
        <p class="mb-3">手のシワは、年齢だけで決まるわけではありません。</p>
        <p class="mb-3">実は <strong>“固定”ではなく、“日替わりで見え方が変わる”</strong> パーツなのです。</p>
        <p class="mb-3">その理由は、手元の状態が  <strong>「水分量」「柔らかさ」「血行」</strong> に左右されるから。</p>
        <ul class="mb-3">
          <li>湿度が低い日は水分が奪われ、シワが立ちやすい</li>
          <li>手洗いやPC作業の摩擦で、皮膚が一時的に“硬く”なる</li>
          <li>朝はむくみでふっくら、夕方は乾燥でシワが深く見える</li>
          <li>手は顔より薄いため、この変動が目視でわかりやすい</li>
        </ul>
        <p>つまり、“今日はシワが目立つ”という現象は珍しいことではなく、むしろ自然。だからこそ、毎日のケアが手元の印象を大きく左右します。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202510_03.png">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202510_04.png">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <h3 class="mb-3">薄い皮膚には“柔らかさ”を戻すケアが最も効く</h3>
        <p class="mb-3">手の皮膚は薄くて乾きやすいため、<br>単にうるおわせるだけでなく<br><strong>“柔らかさを取り戻すケア”</strong> が重要です。</p>
        <p class="mb-3">マナビス化粧品の新作ハンドクリームは、<br>まさにこの“柔らかさケア”に着目した処方。</p>
      </div>
    </div>

    <div>
      <p class="mb-3">● 皮脂に近い植物オイルで、硬くなった手肌をほぐす</p>
      <ul class="mb-3">
        <li>ホホバ種子油</li>
        <li>マカデミア種子油</li>
      </ul>
      <p class="mb-3">これらは人の皮脂構造に近く、<br>乾燥や摩擦で硬くなった皮膚に、自然な柔らかさを取り戻します。</p>
      <p class="mb-3">● シア脂で“守る膜”をつくり、乾燥から手を保護</p>
      <p class="mb-3">薄い手肌のバリアを支え、シワの折れ線が深くなるのを防ぎます。</p>
      <p class="mb-3">● 2種のヒアルロン酸で“ふっくら”と水分を抱え込む</p>
      <ul class="mb-3">
        <li>ヒアルロン酸Na</li>
        <li>ヒアルロン酸ヒドロキシプロピルトリモニウム</li>
      </ul>
      <p class="mb-3">キメが整い、光の反射によってシワが薄く見える効果も。</p>
      <p class="mb-3">● ヒメフウロ・ユズ・アロエで、キメと透明感を引き出す</p>
      <p class="mb-3">薄い皮膚に必要な“やわらかい明るさ”を支えます。</p>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">毎日違う“手の状態”を、今日から整える</h3>
        <p class="mb-3">手は、気温・湿度・摩擦・血行などの影響を受けやすく、<br><strong>状態が変わりやすい＝印象も変わりやすいパーツ。</strong><br>だからこそ、<br>今日の手を丁寧に整えることが、未来の手元の印象をつくります。</p>
        <ul class="mb-3">
          <li>朝：乾燥の気配を先回りしてうるおいをキープ</li>
          <li>日中：手洗い後の硬さをリセット</li>
          <li>夜：柔らかさを戻してふっくら整える</li>
        </ul>
        <p>そのすべてを、ベタつかず心地よく続けられる処方にこだわりました。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202510_05.png">
      </div>
    </div>
    
    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202510_06.png">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-60">
        <p class="mb-3">手は顔より薄い“敏感パーツ”なのに、働き続ける忙しい部分。</p>
        <p class="mb-3">日によってシワが深く見えるのは、手の状態が繊細に変化している証拠です。</p>
        <p class="mb-3">だからこそ、</p>
        <p class="mb-3"><strong>柔らかさと水分を満たすケアが、手元の印象を優しく支えてくれる。</strong></p>
        <p>今日の手をいたわることから、<br>美しい印象は少しずつ積み重なっていきます。</p>
      </div>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_01.jpg">
      <div class="layer-text">
        <p class="mb-3">日によって変わりやすい手元の印象を整えるには、<br>“その日の状態”に寄り添いながら、<br>柔らかさとうるおいを同時に満たすケア が欠かせません。</p>
        <p class="mb-3">そこでおすすめしたいのが、<br>マナビス化粧品が手肌の特性に着目して開発した<br>新作ハンドクリーム です。</p>
        <p class="mb-3">手の皮膚は顔より薄く、乾燥と摩擦の影響を受けやすいパーツ。<br>そのため、オイル・保護膜・水分のバランスを細やかに整えることが、<br>シワの見え方に大きく関わります。</p>
        <p>マナビスのハンドクリームは、<br>皮脂構造に近い植物オイル×柔軟効果 × 保護膜 × ヒアルロン酸<br>という多方向アプローチで、手肌に必要な“やわらかさ”を丁寧に支えます。</p>
      </div>
    </div>
    
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}
ul {
  list-style: disc;
  margin-left: 25px;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_01.jpg');
  background-size: cover;
  background-position: center;
  min-height: 500px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  /* padding: 10px; */
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
  justify-content: flex-start;
}
.feature-row_column_list {
  align-items: inherit;
  justify-content: center;
}
.feature-row_product_item {
  width: 25%;
  padding: 5px;
  text-align: center;
}
.feature-row_column_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}
.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide img {
  width: 100%;
  height: 422px;
  object-fit: cover;
  object-position: left;
}
.img-top-slide_text {
  position: absolute;
  bottom: 30px;
  right: 30px;
  color: #fff;
}
.img-top-slide_text h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text h2 span {
  font-size: .6em;
}

.layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner,.layer_03 .layer-text .layer-text-inner,.layer_04 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span,.layer_03 .layer-text .layer-text-inner h2 span,.layer_04 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_05.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_03 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_06.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_04 {
      position: relative;
      display: flex;
      align-items: flex-start;
      background-image: url('../../assets/img/column/202501_07.jpg');
      background-size: cover;
      min-height: 600px;
      padding: 60px;
    }
    .layer_02 img,.layer_03 img,.layer_04 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text,.layer_03 .layer-text,.layer_04 .layer-text {
      padding: 15px;
      max-width: 45%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
    .img-top-slide_text {
      left: 10px;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }
   .feature-row.step .step-item {
    width: 33.33%;
   }
   .img-top-slide img {
    height: 650px;
   }
}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item, .feature-row_column_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>